module.exports = __webpack_public_path__ + "media/T02.7882e2e7.mp4";